export default "__VITE_ASSET__CvZI1gYM__"